import http from "./httpService";

export function getJwt() {
  return localStorage.getItem("token");
}

http.setJwt(getJwt());

export function handleLogin(user) {
  return http.post(`${process.env.REACT_APP_PUBLIC_PATH}users/login`, user);
}
